import React, { useRef, useEffect, useState } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBIcon,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
} from "mdb-react-ui-kit";
import proficon from "../assets/images/proficon.png";
import baricon from "../assets/images/baricon.png";
import backarrow from "../assets/images/backarrow.png";

import Table from "./Table";
import DataTable from "./DataTable";
import voucherDateAndTimeFormatter from "../utilities/voucherDateAndTimeFormatter";
import { useLocation, useNavigate } from "react-router-dom";
import TotalRegisteredMembersDataTable from "./apiComponents/TotalRegisteredMembersDataTable";
import Loader from "./Loader";
import axios from "axios";
import API_BASE_URL from "../utilities/apiConfig";
import axiosInstance from "../utilities/apiConfig";

const TotalRegMembers = () => {
  const [acceptedMembershipDetails, setAcceptedMembershipDetails] = useState(
    []
  );
  const [loading, setLoading] = useState(false);

  const handleGetAcceptedRegistrationRequest = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Registration/accepted_registration_requests`
      );
      //debugger;
      console.log("accpted request data", response.data);
      if (response.data.response.statusCode === 200) {
        setAcceptedMembershipDetails(response.data.acceptedRequests);
      } else {
        setAcceptedMembershipDetails([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetAcceptedRegistrationRequest();
  }, []);

  const formatRegData = voucherDateAndTimeFormatter(acceptedMembershipDetails, [
    "registrationDate",
    "appliedDate",
    "dateOfBirth",
    "mentorJoiningDate",
    "retirementYear",
  ]);

  const handleClick = (event, cellValues) => {
    console.log("button executed", cellValues);
  };

  const newMembershipRequestTableColumns = [
    {
      field: "advocateBarId",
      headerName: "Registration No",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relationshipType",
      headerName: "Relationship Type",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relativeName",
      headerName: "Relative Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "mobileNumber",
      headerName: "Mobile Number",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 180,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "registrationDate",
      headerName: "Registration Date",
      type: "text",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },

    // { field: 'permanentAddress', headerName: 'Permanent Address', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },

    // { field: 'appliedDate', headerName: 'Applied Date', type: 'text', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // // { field: 'barAssociationId', headerName: 'Bar Association ID', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'dateOfBirth', headerName: 'Date of Birth', type: 'text', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'bloodGroup', headerName: 'Blood Group', minWidth: 120, flex: 1, align: 'left', headerAlign: 'left' },

    // { field: 'isPreviousDepartment', headerName: 'Previous Department', type: 'boolean', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'previousDepartment', headerName: 'Previous Department', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'retirementYear', headerName: 'Retirement Year', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },

    // { field: 'mentorAdvocateBarId', headerName: 'Mentor Advocate Bar ID', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'mentorAdvocateName', headerName: 'Mentor Advocate Name', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'mentorJoiningDate', headerName: 'Mentor Joining Date', type: 'text', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'chamberNumber', headerName: 'Chamber Number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },

    // // { field: 'pendingRequestId', headerName: 'Pending Request ID', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },

    // {
    //   field: "aadharDocument",
    //   headerName: 'Aadhar',

    //   renderCell: (cellValues) => {
    //     return (
    //       <MDBBtn
    //         variant="contained"
    //         color="primary"
    //         onClick={(event) => {
    //           handleClick(event, cellValues);
    //         }}
    //         size='sm'
    //         className='py-1'
    //       >
    //         View
    //       </MDBBtn>
    //     );
    //   }
    // },

    // // { field: 'aadharDocument', headerName: 'Aadhar Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'affidavitDocument', headerName: 'Affidavit Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'highSchoolDocument', headerName: 'High School Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'intermediateDocument', headerName: 'Intermediate Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'graduationDocument', headerName: 'Graduation Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'postGraduationDocument', headerName: 'Post Graduation Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'doctorateDocument', headerName: 'Doctorate Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },

    // { field: 'status', headerName: 'Status', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' }
  ];
  return (
    <>
      {loading && <Loader />}
      <MDBContainer fluid>
        <TotalRegisteredMembersDataTable
          TableData={formatRegData}
          tableName="Registred Bar Members"
          TableColumns={newMembershipRequestTableColumns}
          height={750}
        />
      </MDBContainer>
    </>
  );
};

export default TotalRegMembers;
